export default "__VITE_ASSET__B5VGnUT4__"